import { render, staticRenderFns } from "./robotArmDocking.vue?vue&type=template&id=00537958&scoped=true&"
import script from "./robotArmDocking.vue?vue&type=script&lang=js&"
export * from "./robotArmDocking.vue?vue&type=script&lang=js&"
import style0 from "./robotArmDocking.vue?vue&type=style&index=0&id=00537958&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00537958",
  null
  
)

export default component.exports